<template>
    <div class="page-header align-items-start min-vh-100 mbr-change">
        <span class="mask bg-white"></span>
        <div class="notifications">
            <material-alert v-if="error" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
            {{ error }}
            </material-alert>
        </div>
        <section class="mbr-change__step">
            <form role="form" class="mbr-change__form">
                <div class="mbr-change__group">
                    <div>
                        <h1 class="mbr-change__title">{{ $t('passcode.create_title') }}</h1>
                        <p class="mbr-change__sub">{{ $t('passcode.create_sub') }}</p>
                    </div>
                    <div id="otp" class="mbr-change__pin">
                        <passcode-pin
                            ref="inputEnterPasscode"
                            :should-auto-focus="true"
                            :aria-label="$t('passcode.new_passcode')"
                            @on-complete="handleOnCompleteAlreadyPasscode"
                            v-model="form.passcode"
                        />
                    </div>
                </div>

                <div class="mbr-change__group">
                    <div>
                        <h2 class="mbr-change__title">{{ $t('passcode.confirm_title') }}</h2>
                        <p class="mbr-change__sub">{{ $t('passcode.confirm_sub') }}</p>
                    </div>
                    <div id="otp" class="mbr-change__pin">
                        <passcode-pin
                            ref="inputEnterPasscodeConfirm"
                            :should-auto-focus="false"
                            :aria-label="$t('passcode.confirm_passcode')"
                            @on-complete="handleOnCompleteAlreadyPasscode1"
                            v-model="form.passcode1"
                        />
                    </div>
                </div>
            </form>
            <passcode-keypad class="mbr-change__keypad" />
        </section>
        <div class="position-fixed top-1 end-1 z-index-2">
            <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
                :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
                :close-handler="closeSnackbar" />
        </div>
    </div>
</template>

<script>
    import MaterialAlert from "@/components/MaterialAlert.vue";
    import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
    import PasscodePin from "@/components/PasscodePin.vue";
    import PasscodeKeypad from "@/components/PasscodeKeypad.vue";
    import TokenService from "../services/token.service";
    import router from "@/router";
    import { localStorageName, getMerchantCode } from "@/config/utils";
    import { errorMessage } from "@/utils/errorMessage";

    export default {
        name: "Changepasscode",
        components: {
            MaterialAlert,
            MaterialSnackbar,
            PasscodePin,
            PasscodeKeypad
        },
        data() {
            return {
                form: {
                    phone_code: '65',
                    phone_number: '',
                    passcode: '',
                    passcode1: '',
                },
                snackbar: null,
                error: '',
                merchantCode: "",
                branchCode: ""
            };
        },
        mounted() {
            const merchantCode = getMerchantCode();
            this.merchantCode = merchantCode ? `/${merchantCode}` : "";
            const branchCode = localStorage.getItem(localStorageName("BRANCH_CODE"), "");
            this.branchCode = branchCode ? `/${branchCode}` : "";

            const token = TokenService.getLocalAccessToken();
            if (!token) {
                router.push(this.merchantCode + this.branchCode+ '/sign-in');
            }

            const user = JSON.parse(localStorage.getItem(localStorageName("member")));
            if(user && user.data && user.data.user) {
                this.form.phone_number = user?.data.user.phone_number;
            }
        },
        methods: {
            handleLogin: function () {
                this.successful = false;
                this.loading = true;
                this.$store.dispatch("auth/changePasscode", this.form).then(
                    (data) => {
                    if (data != undefined && !data.result.isSuccess) {
                        this.snackbar = 'danger'
                        this.message = errorMessage(data.result.message)
                        this.setTimeOutNotification();
                    } else {
                        this.snackbar = 'success'
                        this.message = this.$t("change_passcode.updated")
                        setTimeout(() => {
                            router.push(this.merchantCode+"/home");
                        }, 1500);
                    }
                    },
                    (error) => {
                    console.log('ERROR' + error)
                    }
                );
            },
            closeSnackbar() {
                this.snackbar = null;
            },
            setTimeOutNotification() {
                setTimeout(() => {
                    this.snackbar = null;
                }, 3000);
            },
            handleOnCompleteAlreadyPasscode: function (value) {
                this.form.passcode = value;
                if(this.form.passcode != "" && this.form.passcode1 != "") {
                    if(this.form.passcode !== this.form.passcode1) {
                        this.snackbar = 'danger'
                        this.message = this.$t("change_passcode.mismatch")
                        this.setTimeOutNotification();
                        return;
                    }
                    this.handleLogin();
                }
                this.$nextTick(() => {
                    this.$refs.inputEnterPasscodeConfirm.$el.querySelector('input').focus();
                });
            },
            handleOnCompleteAlreadyPasscode1: function (value) {
                this.form.passcode1 = value;
                if(this.form.passcode != "" && this.form.passcode1 != "") {
                    if(this.form.passcode !== this.form.passcode1) {
                        this.snackbar = 'danger'
                        this.message = this.$t("change_passcode.mismatch")
                        this.setTimeOutNotification();
                        return;
                    }
                    this.handleLogin();
                }
            },
        },
    };
</script>
<style scoped>
/* MBR017 Heritage Hearth change passcode — rendered inside the app shell */
/* Unscoped `* { font-family: Poppins }` in Landing / Store / RewardCatalogue hits every element;
   :where() keeps this at one attribute's specificity so class rules (titles) still win */
:where(:not(.material-icons-round)) {
    font-family: var(--mbr-font-body);
}

.mbr-change.page-header {
    flex-direction: column;
    font-family: var(--mbr-font-body);
}

.mbr-change__step {
    position: relative;
    z-index: 1;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
    padding: 40px 24px 40px;
    background: var(--mbr-color-canvas);
    /* Passcode screens keep the design canvas; brand colours follow the theme tokens (MBR128) */
    --mbr-color-canvas: #FFF8F7;
}

.mbr-change__form {
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 0;
}

/* Fixed gap, not margin-top:auto: .page-header is 100vh tall but starts below the
   navbar, so pinning the keypad to its bottom pushes the last row off screen */
.mbr-change__keypad {
    flex: none;
    margin-top: 40px;
}

.mbr-change__group {
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: center;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-change__title {
    margin: 0;
    font-family: var(--mbr-font-headline);
    font-size: var(--mbr-headline-md-size);
    font-weight: 800;
    line-height: var(--mbr-headline-md-line);
    letter-spacing: -0.02em;
    color: var(--mbr-color-ink-headline);
}

.mbr-change__sub {
    margin: 6px 0 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: var(--mbr-color-ink-muted);
}

.mbr-change__pin {
    display: flex;
    justify-content: center;
}
</style>
